// eslint-disable-next-line import/no-extraneous-dependencies
import cloneDeep from 'lodash.clonedeep';

// export function getExplorerInfo() {
//     let explorer = window.navigator.userAgent.toLowerCase();
//     //ie
//     if (explorer.indexOf('msie') >= 0) {
//         const ver = explorer.match(/msie ([\d.]+)/)[1];
//         return { type: 'IE', version: ver };
//     }
//     //ie11
//     if (!!window.ActiveXObject || "ActiveXObject" in window) {
//         return { type: 'IE', version: '11.0' };
//     }
//     //firefox
//     else if (explorer.indexOf('firefox') >= 0) {
//         const ver = explorer.match(/firefox\/([\d.]+)/)[1];
//         return { type: 'Firefox', version: ver };
//     }
//     //Chrome
//     else if (explorer.indexOf('chrome') >= 0) {
//         const ver = explorer.match(/chrome\/([\d.]+)/)[1];
//         return { type: 'Chrome', version: ver };
//     }
//     //Opera
//     else if (explorer.indexOf('opera') >= 0) {
//         const ver = explorer.match(/opera.([\d.]+)/)[1];
//         return { type: 'Opera', version: ver };
//     }
//     //Safari
//     else if (explorer.indexOf('Safari') >= 0) {
//         const ver = explorer.match(/version\/([\d.]+)/)[1];
//         return { type: 'Safari', version: ver };
//     }
//     else {
//         return { type: 'Unknown', version: 0 };
//     }
// }

export function isLowIE() {
  // 这个本身是判断IE浏览器的方法，但是在IE11中不再适用，所以可以用来判断IE10及以下（认为是低版本IE）;
  return window.navigator.userAgent.toLowerCase().indexOf('msie') >= 0;
}

export function isIE() {
  const explorer = window.navigator.userAgent.toLowerCase();
  return (
    explorer.indexOf('msie') >= 0 ||
    // eslint-disable-next-line no-useless-escape
    !!navigator.userAgent.match(/Trident.*rv\:11\./) ||
    !!window.ActiveXObject ||
    'ActiveXObject' in window
  );
}

// export function isWindows() {
//     return /windows|win32/i.test(navigator.userAgent);
// }

export function checkOS() {
  // const userAgent = navigator.userAgent;
  const isMac =
    navigator.platform == 'Mac68K' ||
    navigator.platform == 'MacPPC' ||
    navigator.platform == 'Macintosh' ||
    navigator.platform == 'MacIntel';
  if (isMac) return 'MacOS';

  const isWin = navigator.platform == 'Win32' || navigator.platform == 'Windows';
  const isUnix = navigator.platform == 'X11' && !isWin && !isMac;
  if (isUnix) return 'Unix';

  const isLinux = String(navigator.platform).indexOf('Linux') > -1;
  if (isLinux) return 'Linux';

  if (isWin) return 'Windows';

  // if (isWin) {
  //     var findFlag = userAgent.indexOf("Windows NT 5.0") > -1 || userAgent.indexOf("Windows 2000") > -1;
  //     if (findFlag) return "Win2000";
  //     var findFlag = userAgent.indexOf("Windows NT 5.1") > -1 || userAgent.indexOf("Windows XP") > -1;
  //     if (findFlag) return "WinXP";
  //     var findFlag = userAgent.indexOf("Windows NT 5.2") > -1 || userAgent.indexOf("Windows 2003") > -1;
  //     if (findFlag) return "Win2003";
  //     var findFlag= userAgent.indexOf("Windows NT 6.0") > -1 || userAgent.indexOf("Windows Vista") > -1;
  //     if (findFlag) return "WinVista";
  //     var findFlag = userAgent.indexOf("Windows NT 6.1") > -1 || userAgent.indexOf("Windows 7") > -1;
  //     if (findFlag) return "Win7";
  //     var findFlag = userAgent.indexOf("Windows NT 6.2") > -1 || userAgent.indexOf("Windows 8") > -1;
  //     if (findFlag) return "Win8";
  //     var findFlag = userAgent.indexOf("Windows NT 6.3") > -1 || userAgent.indexOf("Windows 8.1") > -1;
  //     if (isWifindFlagn8_1) return "Win8.1";
  //     var findFlag = userAgent.indexOf("Windows NT 6.4") > -1 || userAgent.indexOf("Windows 10") > -1;
  //     if (isWifindFlagn8_1) return "Win10";
  //     return 'win';
  // }

  return 'other';
}

export function isWindows() {
  return checkOS() === 'Windows';
}

export function isLinux() {
  // TODO: 是否将Linux/Unix统一对待？
  return checkOS() === 'Linux' || checkOS() === 'Unix';
}

export function isMacOS() {
  return checkOS() === 'MacOS';
}

export function checkMobileOS() {
  const u = navigator.userAgent;
  // console.log(u);
  // const app = navigator.appVersion;
  return {
    // trident: u.indexOf('Trident') > -1, //IE内核
    // presto: u.indexOf('Presto') > -1, //opera内核
    // webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
    // gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1,//火狐内核
    mobile: !!u.match(/AppleWebKit.*Mobile.*/), // 是否为移动终端
    ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
    android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, // android终端
    // iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
    // iPad: u.indexOf('iPad') > -1, //是否iPad
    webApp: u.indexOf('Safari') == -1, // 是否web应该程序，没有头部与底部
    weixin: u.indexOf('MicroMessenger') > -1, // 是否微信 （2015-01-22新增）
    // qq: u.match(/\sQQ/i) == " qq" //是否QQ
  };
}

export function isValidURL(str_url) {
  const strRegex =
    '^((https|http|ftp|rtsp|mms)?://)' +
    "?(([0-9a-z_!~*'().&=+$%-]+: )?[0-9a-z_!~*'().&=+$%-]+@)?" + // ftp的user@
    '(([0-9]{1,3}.){3}[0-9]{1,3}' + // IP形式的URL- 199.194.52.184
    '|' + // 允许IP和DOMAIN（域名）
    "([0-9a-z_!~*'()-]+.)*" + // 域名- www.
    '([0-9a-z][0-9a-z-]{0,61})?[0-9a-z].' + // 二级域名
    '[a-z]{2,6})' + // first level domain- .com or .museum
    '(:[0-9]{1,5})?' + // 端口- :80
    '((/?)|' + // a slash isn't required if there is no file name
    "(/[0-9a-z_!~*'().;?:@&=+$,%#-]+)+/?)$";
  const re = new RegExp(strRegex);
  // re.test()
  if (re.test(str_url)) {
    return true;
  }
  return false;
}

export const isDevEnv = () => {
  const { NODE_ENV } = process.env;
  return NODE_ENV === 'development';
};

export const getRealLength = str => {
  let len = 0;
  for (let i = 0; i < str.length; i++) {
    const a = str.charAt(i);
    // eslint-disable-next-line no-control-regex
    if (a.match(/[^\x00-\xff]/gi) != null) {
      len += 2;
    } else {
      len += 1;
    }
  }
  return len;
};

export const uniqueObjectArray = (arr, key) => {
  const res = new Map();
  return arr.filter(item => !res.has(item[key]) && res.set(item[key], 1));

  // let hash = {};
  // return arr.reduce((accum, item) => {
  //     hash[item[key]] ? '' : hash[item[key]] = true && accum.push(item);
  //     return accum;
  // }, []);
};

export const debounce = (fn, delay) => {
  let timer = null;

  const debouncedFn = (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      return fn(...args);
    }, delay);
  };

  return debouncedFn;
};

export const deepClone = cloneDeep;

// TODO: 简单的版本号判断，最好可以使用semver；
export const compareVersions = (version1, version2) => {
  // 如果版本号带有 V 前缀，去除该前缀
  version1 = version1.replace(/^V/i, '');
  version2 = version2.replace(/^V/i, '');

  // 分割版本号为数字数组
  const arr1 = version1.split('.').map(Number);
  const arr2 = version2.split('.').map(Number);

  // 比较每个部分的数字
  for (let i = 0; i < 3; i++) {
    if (arr1[i] > arr2[i]) {
      return 1; // version1 大于 version2
    }
    if (arr1[i] < arr2[i]) {
      return -1; // version1 小于 version2
    }
  }

  return 0; // 版本号相等
};
